"use client";

import React, { useEffect, useState } from "react";
import { ReactInstaStoriesProps, GlobalCtx, Story, Tester, Renderer } from "./interfaces";
import Container from "./components/Container";
import GlobalContext from "./context/Global";
import StoriesContext from "./context/Stories";
import { getRenderer } from "./util/renderers";
import { renderers as defaultRenderers } from "./renderers/index";
import withHeader from "./renderers/wrappers/withHeader";
import withSeeMore from "./renderers/wrappers/withSeeMore";

const InstagramStory = function (props: ReactInstaStoriesProps) {
    const renderers = props.renderers ? props.renderers.concat(defaultRenderers) : defaultRenderers;
    const context: GlobalCtx = {
        width: props.width || 360,
        height: props.height || 640,
        loader: props.loader,
        header: props.header,
        storyContainerStyles: props.storyContainerStyles,
        storyInnerContainerStyles: props.storyInnerContainerStyles,
        storyStyles: props.storyStyles,
        progressContainerStyles: props.progressContainerStyles,
        progressWrapperStyles: props.progressWrapperStyles,
        progressStyles: props.progressStyles,
        loop: props.loop,
        defaultInterval: props.defaultInterval || 4000,
        isPaused: props.isPaused,
        currentIndex: props.currentIndex,
        onStoryStart: props.onStoryStart,
        onStoryEnd: props.onStoryEnd,
        onAllStoriesEnd: props.onAllStoriesEnd,
        onNext: props.onNext,
        onPrevious: props.onPrevious,
        keyboardNavigation: props.keyboardNavigation,
        preventDefault: props.preventDefault,
        preloadCount: props.preloadCount || 1,
    }
    const [stories, setStories] = useState<{ stories: Story[] }>({ stories: generateStories(props.stories, renderers) });

    useEffect(() => {
        setStories({ stories: generateStories(props.stories, renderers) });
    }, [props.stories, props.renderers]);

    return (
        <GlobalContext.Provider value={context}>
            <StoriesContext.Provider value={stories}>
                <Container />
            </StoriesContext.Provider>
        </GlobalContext.Provider>
    );
}

const generateStories = (stories: Story[], renderers: { renderer: Renderer, tester: Tester }[]) => {
    return stories.map(s => {
        let story: Story = {};

        if (typeof s === 'string') {
            story.url = s;
            story.type = 'image';
        } else if (typeof s === 'object') {
            story = Object.assign(story, s);
        }

        const renderer = getRenderer(story, renderers);
        story.originalContent = story.content;
        story.content = renderer;
        return story
    })
};

export const WithHeader = withHeader;
export const WithSeeMore = withSeeMore;

export default InstagramStory;
